import { CoDocumentocobranza } from "../../codocumentocobranza/dominio/CoDocumentocobranza";
import { CoCobranzadetalle } from "../../cocobranzadetalle/dominio/CoCobranzadetalle";

export class CoCobranzaPk {
    unidadreplicacion: string;
    cobranzanumero: number;
}
export class CoCobranza {

    pk: CoCobranzaPk;
    constructor() {
        this.pk = new CoCobranzaPk();
        this.documentos = [];
        this.detalle = [];
    }

    companiasocio: string;
    fechapreparacion: Date;
    fechacobranza: Date;
    cliente: number;
    cobrador: number;
    cajero: number;
    monedacodigo: string;
    estado: string;
    ultimousuario: string;
    ultimafechamodif: Date;
    unidadnegocio: string;
    indicadorarchivamiento: number;

    auxNombreCliente: string;

    documentos: CoDocumentocobranza[];
    detalle: CoCobranzadetalle[];

}